export default __webpack_public_path__ + "static/media/playzone-fit-Wack-a-tag-1.f600d3d4.jpg";